
import { DateHelper } from '@/helpers/DateHelper';
import { GetDisplayDate } from '@/helpers/ObjectHelper';
import { StringHelper } from '@/helpers/StringHelper';
import { OrderlineDetails } from '@/store/models/OrderlineModel';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import J1LDateIcon from '@/components/J1LDateIcon.vue';
import J1lImg from '@/components/J1lImg.vue';
import RushIcon from '@/components/Icons/RushIcon.vue';
import AdminService from '@/services/admin-service';
import { SetSnackBar } from '@/helpers/SnackbarHelper';
import { ReprintService } from '@/services/reprint-service';
@Component({
  components: {
    J1LDateIcon,
    RushIcon,
    J1lImg
  }
})
export default class OrderZeroOutDialog extends Vue {
  /* Properties */
  /* Store Actions */
  /* Watchers */
  /* Data */
  isLoading: boolean = false;
  dialog: boolean = false;
  orderlines: OrderlineDetails[] = [];
  reprintQuantity: number = 100;
  shouldBeZeroedOut: boolean = true;
  isVisibleInUI: boolean = true;
  allReprintReasons: Array<{ Id: number; ReprintReason: string }> = [];
  reprintReason = 'N/A';

  /* Computed */
  /* Async Functions */
  async reprintOrderline() {
    this.isLoading = true;
    try {
      let orderlineId = this.orderlines[0].Id;
      // await AdminService.ReprintOrderlineForCustomer(
      //   orderlineId,
      //   this.reprintReason,
      //   this.reprintQuantity,
      //   this.shouldBeZeroedOut,
      //   this.isVisibleInUI
      // );

      console.log(
        `${orderlineId} ${this.reprintReason} ${this.reprintQuantity} ${this.shouldBeZeroedOut} ${this.isVisibleInUI}`
      );
      this.orderlines[0].RefreshAll = true;
      this.$emit('orderline-reprinted', this.orderlines[0]);
      SetSnackBar('Successfully created orderline reprint');
    } catch (err) {
      SetSnackBar(
        'Error has occured, please contact techsupport@just1label.com if you are experiencing any issues'
      );
    }
    this.isLoading = false;
    this.closeDialog();
  }
  /* Utility Functions */
  async openDialog(orderline: OrderlineDetails) {
    this.orderlines = [orderline];
    this.reprintQuantity = orderline.Quantity;
    this.dialog = true;

    Promise.all([this.GetReprintReasons()]);
  }
  closeDialog() {
    this.dialog = false;
  }
  getTextColor(status: string) {
    return StringHelper.getStatusTextColorClass(status);
  }
  getBackgroundColorByStatus(status: string) {
    return StringHelper.getStatusTextBackgroundColorClass(status);
  }
  getBorderColorByStatus(status: string) {
    return StringHelper.getStatusTextBorderColorClass(status);
  }
  shouldUseNullDate(orderline: OrderlineDetails) {
    let statuses = ['Production hold', 'Processing Error(s)', 'Waiting on Codes'];
    return statuses.includes(orderline.OrderStatus.OrderStatusDisplay);
  }
  GetDisplayDate(orderline: OrderlineDetails) {
    return GetDisplayDate(orderline);
  }
  GetShipVerbiage(orderline: OrderlineDetails) {
    return DateHelper.GetShipVerbiage(orderline);
  }
  backgroundColor(i: number) {
    return i % 2 === 0 ? 'card-light-grey-background' : 'card-dark-grey-background';
  }
  required(v) {
    return !!v || 'Field is required';
  }
  /* Loaders */
  /* Mounted */

  async GetReprintReasons() {
    try {
      if (this.allReprintReasons.length > 0) return;
      const { data } = await ReprintService.GetReprintReasons();
      this.allReprintReasons = data;
      this.allReprintReasons.push({ Id: 0, ReprintReason: 'New Reason' });
      this.reprintReason = this.allReprintReasons[0].ReprintReason;
    } catch (err) {
      SetSnackBar('Error getting reprint reasons');
    }
  }
  /* Created */
  /* Emmited Functions */
}
